import { render } from "./Notificacoes.vue?vue&type=template&id=352deae0"
import script from "./Notificacoes.vue?vue&type=script&lang=ts"
export * from "./Notificacoes.vue?vue&type=script&lang=ts"
script.render = render

export default script